import { abortable as abortableBase } from "@enfusion-ui/utils";
import queryString from "query-string";
export default (restServer) => {
    const abortable = (c) => abortableBase(restServer, c);
    return {
        GET_HOLIDAY_CENTERS: abortable((instrumentId, fundIds) => queryString.stringifyUrl({
            url: "/internal/api/holidays/holidayCenters",
            query: { instrumentId, fundIds },
        })),
        GET_HOLIDAYS: abortable((holidayCenterIds) => `/internal/api/holidays/holidayCenters/holidays?holidayCenterIds=${holidayCenterIds.join(",")}`),
    };
};
